import React from 'react';
import { AddEmployeesTable } from 'components/rfq/monitor-add-employees/AddEmployeesTable';
import { RFQ_PROPOSAL_CARD_DATA } from 'global/checklists-helpers/RFQProposalChecklistHelper';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';
import { observer } from 'mobx-react-lite';
import {
  MonitorAddEmployeesPageStore,
  MonitorAddEmployeesPageStoreContext,
  useMonitorAddEmployeesPageStore,
} from 'store/pages/rfq/monitor-add-employees/pageStore';
import { TableManagementPanel } from 'components/rfq/monitor-add-employees/TableManagementPanel';
import useEnrollmentQuoteUrlParams from 'global/hooks/useEnrollmentQuoteUrlParams';
import { PageFooter, PageHeader } from '@insurancemenu/imenu-components-lib';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { onBack, onComplete, stepCanComplete } = useMonitorAddEmployeesPageStore();

  return (
    <>
      <PageHeader
        title={RFQ_PROPOSAL_CARD_DATA.MONITOR_ADD_EMPLOYEES.title}
        subtitle={RFQ_PROPOSAL_CARD_DATA.MONITOR_ADD_EMPLOYEES.text}
        onBackButtonClick={onBack}
      />
      <TableManagementPanel />
      <AddEmployeesTable />
      <PageFooter onBack={onBack} onComplete={onComplete} disableCompleteButton={!stepCanComplete} />
    </>
  );
});

const MonitorAddEmployeesPage: React.FC = observer(() => {
  const { cartId, groupId, periodId } = useEnrollmentQuoteUrlParams();

  return (
    <RFQStatusLayout>
      <MonitorAddEmployeesPageStoreContext.Provider
        value={new MonitorAddEmployeesPageStore({ groupId, cartId, periodId })}
      >
        <PageContent />
      </MonitorAddEmployeesPageStoreContext.Provider>
    </RFQStatusLayout>
  );
});

export default MonitorAddEmployeesPage;
